export const getIdentificationData = () => {
  let storageObject;
  try {
    const storageVariables = sessionStorage.getItem("activeAccount") || "{}";
    storageObject = JSON.parse(storageVariables);
  } catch {
    storageObject = {};
  }
  return {
    token: `Bearer ${storageObject?.idToken || ""}`,
    employeeId: storageObject?.idTokenClaims?.employeeid || "",
  };
};

const getUserData = () => {
  const userData = localStorage.getItem("user");
  if (!userData) return {};
  return JSON.parse(userData);
};

export const userInfo = () => {
  const parsedUser = getUserData();
  return {
    name: parsedUser.name || "",
    email: parsedUser.email || "",
    userId: parsedUser.userId || "",
  };
};
